import React, { useRef } from 'react'
import TextEditor from '../../../../../../../../../../../shared-components/TextEditor';
import DropdownValueHandler from '../../../../../../../../../../shared/SuperSearch/DropdownValueHandler';
import { useSelector } from 'react-redux';
import { isSignedOrToBeCoSigned } from '../../../utils';
import { FindFirstChild } from '../../../../../../../../../../../utils/FindMenuOption';

const AdditionalInfo = ({ children }) => {
    return (<>{children}</>)
}
const AdditionalInfoPreview = (props) => {
    // let { widgetsPreviewData: Data } = props;
    let isEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd;

    const quillAdditionalInfoRef = useRef(null);
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);

    const {
        initialDataPatientName, initialDataAge, initialDataDOB, initialDataAddress, initialDataMobileNumber, initialDataEmail, initialDataEncounterStatus,
        additionalInfoData, setAdditionalInfoData,
        AddDocument,
        setSaveDocumentData,
        getSaveData
        // handleDocumentDelete
    } = props?.additionalInfoWidgetPreviewProps;

    const handleChangeFreeText = (value, type) => {
        if (type === 'AdditionalInfo') {
            setAdditionalInfoData(prev => ({
                ...prev, "AdditionalInfoNotes": value,
            }));
        }
    }

    const handleDocumentDelete = (item, indexToRemove) => {
        const { PatientDocumentID, recordNoClient } = item;

        // Remove from EncounterDocument list by index
        setAdditionalInfoData(prev => {
            const updatedEncounterDocument = prev.EncounterDocument.filter((_, idx) => idx !== indexToRemove);
            return { ...prev, EncounterDocument: updatedEncounterDocument };
        });
        // Update saveDocumentData accordingly
        setSaveDocumentData(prev => {
            if (PatientDocumentID) {
                const exists = prev.some(doc => doc.PatientDocumentID === PatientDocumentID);

                if (exists) {
                    //  Update it to mark as deleted
                    return prev.map(doc =>
                        doc.PatientDocumentID === PatientDocumentID
                            ? { ...doc, Deleted: "true" }
                            : doc
                    );
                } else {
                    //  Push a new deleted object if it doesn't exist yet
                    return [
                        ...prev,
                        {
                            PatientDocumentID,
                            EncounterID: item.EncounterID,
                            Deleted: "true",
                        },
                    ];
                }
            } else if (recordNoClient) {
                //  Remove unsaved local doc entirely
                return prev.filter(doc => doc.recordNoClient !== recordNoClient);
            } else {
                return prev;
            }
        });
    }
    let noValExistText = <p className="text ar-light-color">No data recorded</p>;
    const removeTrailingEmptyLines = (html) => {
        return html.replace(/(<p><br><\/p>\s*)+$/g, '');
    }
    const isVisuallyEmpty = (html = '') => {
        return html.replace(/<[^>]*>/g, '').trim() === '';
    }

    // let additionalNoteText = removeTrailingEmptyLines(Data?.AdditionalInfoNotes || '');

    return (
        <div className="d-flex gap-10">
            <div className="ar-form-counter flex-center">
                <p className='text text-black'>{props?.itemCount}</p>
            </div>
            <div className='bg_yellow min-w-0 p-2 w-100'
            // id={scrollNavIDs.refAdditionalINFO}
            >
                <div className="ar_header d-flex gap-6 align-items-center justify-content-between mb-1"
                // onClick={() => handleAccordionChange('AdditionalINFO')}
                >
                    {/* {activeAccord['AdditionalINFO'] ? <i className="icon-up fs-10 pt-2px"></i> : <i className="icon-down fs-10 pt-2px"></i>} */}
                    <p className="heading font-b fs-13 leter-spacing">I - Additional INFO</p>
                    <div className="d-flex">
                        {((isSignedOrToBeCoSigned.includes(initialDataEncounterStatus))) &&
                            <button className={`btn btn-orange h-100 lh-13 min-w-unset px-10 py-3px rounded ${isEditAllowed ? '' : 'disable'}`} onClick={() => getSaveData("", "", "", 'Save Edit Superbill')}>Save</button>}
                    </div>
                </div>
                {/* {activeAccord['AdditionalINFO'] && */}
                <div className='d-flex flex-column gap-2  w-100 '>
                    {/* {defaultSelectedItems?.documents && */}
                    <div className='d-flex flex-column gap-6'>
                        <div className="d-flex justify-content-between align-items-center"
                        // id={scrollNavIDs.refAdditionalINFODOC}
                        >
                            <p className="heading fs-13"
                            // onClick={() => handleItemsExpanded('D')}
                            >Documents</p>
                            <div className="d-flex align-items-center gap-2">
                                <div onClick={() => AddDocument({ PatientDocumentID: null })}>
                                    <i className="icon-dash-plus add-icon rounded-5 fs-20" ></i>
                                </div>
                            </div>
                        </div>
                        {/* {!itemsCollapsed?.['D'] && ( */}
                        <>
                            {additionalInfoData?.EncounterDocument?.length > 0 &&
                                <div className="py-2 px-1-5 observation-content mb-1 d-flex flex-column gap-2">

                                    {additionalInfoData?.EncounterDocument.map((doc, index) => {
                                        let docType = DropdownValueHandler(DropDowns.DocumentType, doc.DocumentTypeID)
                                        return (
                                            <>
                                                <div className="d-flex align-items-center gap-2">
                                                    <p className='text validate-color cursor-pointer text-nowrap br-right-1 br-clr-light pe-2' onClick={() => AddDocument(doc)}>{doc.FileName}</p>
                                                    <p className="text font-m text-nowrap">Document Type:</p>
                                                    <p className={`text text-nowrap pe-2 ${doc.Description ? 'br-right-1 br-clr-light' : ''} `}>{docType}</p>

                                                    {doc.Description ? <p className="text font-m text-nowrap">Description:</p> : <></>}
                                                    <p className='text text-nowrap validation_message w-100'>{doc.Description}</p>
                                                    <div className="d-flex gap-10 align-items-center ps-10">
                                                        <div className="lh-1">
                                                            <i className='icon-x-cros fs-20 dark-clr' onClick={() => handleDocumentDelete(doc, index)}></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>


                                        )
                                    })}
                                </div>}
                        </>
                        {/* )} */}
                    </div>
                    {/* } */}
                    {/* {defaultSelectedItems?.additionalNotes && */}
                    <div className='d-flex flex-column gap-6'
                    //  id={scrollNavIDs.refAdditionalINFON} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refAdditionalINFON)} onClick={() => handleActiveItem(scrollNavIDs.refAdditionalINFON)}
                    >
                        <p className="heading fs-13"
                        // onClick={() => handleItemsExpanded('IN')}
                        >Notes</p>
                        {/* {!itemsCollapsed?.['IN'] &&
                                ( */}
                        <div className="">
                            <TextEditor
                                quillRef={quillAdditionalInfoRef}
                                value={additionalInfoData.AdditionalInfoNotes}
                                setValue={(value) => handleChangeFreeText(value, 'AdditionalInfo')}
                                placeholderReplacement={true}
                                customDropDown={{
                                    'active': true,
                                    'options': [
                                        { value: initialDataPatientName, display: '$Name', },
                                        { value: initialDataAge, display: '$Age', },
                                        { value: initialDataDOB, display: '$DOB', },
                                        { value: initialDataAddress, display: '$Address', },
                                        { value: initialDataMobileNumber, display: '$Phone', },
                                        { value: initialDataEmail, display: '$Email', },
                                    ]
                                }}
                            />
                        </div>
                        {/* )} */}
                    </div>
                    {/* } */}
                </div>
                {/* } */}
            </div>
        </div>
    )
}

const AdditionalInfoSelectModalView = (props) => {
    let { widgetsPreviewData: Data } = props;

    let noValExistText = <p className="text ar-light-color">No data recorded</p>;
    const removeTrailingEmptyLines = (html) => {
        return html.replace(/(<p><br><\/p>\s*)+$/g, '');
    }
    const isVisuallyEmpty = (html = '') => {
        return html.replace(/<[^>]*>/g, '').trim() === '';
    }

    let additionalNoteText = removeTrailingEmptyLines(Data?.AdditionalInfoNotes || '');

    return (
        <div className="d-flex gap-10">
            <div className="ar-form-counter flex-center">
                <p className='text text-black'>{props?.itemCount}</p>
            </div>
            <div className='d-flex flex-column gap-6 w-100'>
                <div className="d-flex align-items-center justify-content-between">
                    <p class="heading fs-13">I - Additional INFO</p>
                </div>
                <div className="d-flex flex-column gap-6 observation-content">
                    <div className='d-flex flex-column gap-6'>
                        <p class="heading fs-13">Documents</p>

                        {Data?.EncounterDocument?.length > 0 ?
                            <div className="d-flex flex-column gap-1">
                                {Data.EncounterDocument.map((doc) => (
                                    <div className="d-flex align-items-center gap-1">
                                        <p className='text font-m validate-color'>{doc.FileName}</p>
                                        <p className="text">{doc.Description && `- ${doc.Description}`}</p>
                                    </div>
                                )
                                )}
                            </div> :
                            <>{noValExistText}</>}
                    </div>
                    <div className='d-flex flex-column gap-6'>
                        <p className='heading fs-13'>Notes</p>
                        <div>
                            {isVisuallyEmpty(Data.AdditionalInfoNotes) ?
                                noValExistText :
                                <p className="text" dangerouslySetInnerHTML={{ __html: additionalNoteText }}></p>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

AdditionalInfo.Preview = AdditionalInfoPreview
AdditionalInfo.SelectModalView = AdditionalInfoSelectModalView

export default AdditionalInfo